import utils from "@/utils/index"

const env = localStorage.getItem('tz-cortex-env') || 'production';
const disabled = env === 'sandbox';

export default [
  {
    title: 'getPaid',
    icon: 'CheckCircleIcon',
    // tag: 'new',
    tagVariant: 'light-success',
    children: [
      {
        title: 'invoicing',
        icon: 'FileIcon',
        disabled,
        children: [
          {
            title: 'allInvoices',
            route: 'invoice-all',
          },
          {
            title: 'createAnInvoice',
            route: 'invoice-create',
          },
      //     {
      //       title: 'uploadAnInvoice',
      //       route: 'invoice-upload',
      //     },
          {
            title: 'paymentsReceived',
            route: 'invoice-payments',
          },
      //     // {
      //     //   title: 'invoiceRequests',
      //     //   route: 'invoice-requests',
      //     // },
        ],
      },
      {
        title: 'paymentLinks',
        icon: 'LinkIcon',
        disabled,
        children: [
          {
            title: 'history',
            route: 'payment-links',
          },
          {
            title: 'create',
            route: 'payment-links-create',
          },
          {
            title: 'payments',
            route: 'payment-links-payments',
          },
        ],
      },
      // {
      //   title: 'directCharge',
      //   icon: 'LinkIcon',
      //   tagVariant: 'light-success',
      //   children: [
      //     {
      //       title: 'history',
      //       route: 'direct-charge',
      //     },
      //     {
      //       title: 'create',
      //       route: 'direct-charge-create',
      //     }
      //   ],
      // }
      {
        icon: 'CastIcon',
        title: 'requests',
        children: [
          {
            title: 'history',
            route: 'transactions-requests-list',
          },
          {
            title: 'create',
            route: 'transactions-requests-create',
          },
          // {
          //   title: 'apiOnly',
          //   route: 'transactions-requests-list-api',
          // },
          // {
          //   title: 'manualRequests',
          //   route: 'transactions-requests-list-manual-requests',
          // },
          // {
          //   title: 'splitPayments',
          //   route: 'transactions-requests-list-split-payments',
          // },
        ],
      },
    ]
  },
  {
    title: 'transfers',
    icon: 'FileTextIcon',
    children: [
      {
        title: 'history',
        route: 'transfer-all',
      },
      {
        title: 'apiOnly',
        route: 'transfer-api-only',
      },
      {
        title: 'transferTo',
        icon: 'SendIcon',
        children: [
          {
            title: 'tranzakUser',
            route: 'transfer-to-tranzak-user',
          },
          {
            title: 'mobileMoney',
            route: 'transfer-to-mobile-money-account',
          },
          {
            title: 'bankAccount',
            route: 'transfer-to-bank-account',
          },
          // {
            //   title: 'toPrepaidCard',
            //   route: 'transfer-to-prepaid-card',
            // },
          {
            title: 'internalAccounts',
            route: 'transfer-to-linked-account',
          },
        ],
      },
      {
        title: 'massPayments',
        icon: 'ArchiveIcon',
        children: [
          {
            title: 'allTransfers',
            route: 'mass-payments-all',
          },
          {
            title: 'createPayout',
            route: 'mass-payments-create',
          },
          {
            title: 'uploadFile',
            route: 'mass-payments-upload',
          },
          {
            title: 'allPayments',
            route: 'mass-payments-recipients-details',
          },
        ],
      },
      {
        title: 'approvals',
        icon: 'ToggleRightIcon',
        disabled,
        children: [
          {
            title: 'history',
            route: 'approvalsList',
          }
        ]
      },
      {
        title: 'profiles',
        icon: 'UsersIcon',
        children: [
          {
            title: 'recipientGroups',
            route: 'profiles-groups',
          },
          {
            title: 'recipients',
            route: 'profiles-recipients',
          },
        ]
      }
    ]

  },
  {
    title: 'account',
    icon: 'UserIcon',
    children: [
      {
        title: 'balance',
        route: 'account-balance',
        icon: 'BriefcaseIcon'
      },
      {
        title: 'collectionAccounts',
        route: 'account-collection-accounts',
        icon: 'HomeIcon'
      },
      {
        title: 'withheldBalance',
        route: 'account-withheld-balance',
        icon: 'LockIcon'
      },
      {
        title: 'topUpChannels',
        disabled,
        route: 'account-top-up-channels',
        icon: 'ArrowUpIcon'
      },
      // {
      //   title: 'refunds',
      //   route: 'refunds',
      //   icon: 'RewindIcon'
      // },
      // {
      //   title: 'automaticRefunds',
      //   route: 'automatic-refunds',
      //   icon: 'RewindIcon'
      // },
      {
        title: 'realNameVerification',
        icon: 'BoxIcon',
        disabled,
        route: 'account-real-name-verification',
      },
    ],
  },
  {
    title: 'transactions',
    icon: 'LayersIcon',
    children: [
      {
        title: 'history',
        route: 'transactions-all',
        icon: 'ListIcon',
      },
      {
        icon: 'ClockIcon',
        title: 'accountStatement',
        route: 'transactions-account-statement',
        tagVariant: 'light-success'
      },
      // {
        //   title: 'sales',
        //   route: 'transactions-sales',
        // },
        {
        icon: 'FastForwardIcon',
        title: 'paymentsReceived',
        route: 'transactions-inbound',
      },
      {
        icon: 'RewindIcon',
        title: 'paymentsSent',
        route: 'transactions-outbound',
      },
      {
        icon: 'CastIcon',
        title: 'cashOutOrSettlement',
        route: 'transactions-cash-outs',
      },
      {
        icon: 'CheckCircleIcon',
        title: 'verifyThirdPartyTransaction',
        route: 'transactions-verify-third-party-transaction',
      },
      {
        icon: 'CastIcon',
        title: 'automaticSettlement',
        route: 'transactions-automatic-settlement',
      },
      {
        icon: 'CastIcon',
        title: 'paymentAdjustments',
        route: 'transactions-payment-adjustments',
      },
      {
        icon: 'CastIcon',
        title: 'requests',
        children: [
          {
            title: 'history',
            route: 'transactions-requests-list',
          },
          // {
          //   title: 'create',
          //   route: 'transactions-requests-create',
          // },
          {
            title: 'apiOnly',
            route: 'transactions-requests-list-api',
          },
          {
            title: 'manualRequests',
            route: 'transactions-requests-list-manual-requests',
          },
          {
            title: 'splitPayments',
            route: 'transactions-requests-list-split-payments',
          },
        ],
      },
      {
        title: 'refunds',
        route: 'transactions-refunds',
        icon: 'RewindIcon'
      },
      {
        title: 'automaticRefunds',
        route: 'transactions-automatic-refunds',
        icon: 'RewindIcon'
      },
      {
        title: 'uncompletedFlows',
        route: 'transactions-uncompleted-flows',
        icon: 'RewindIcon'
      }
      // {
      //   title: 'bonusRewards',
      //   route: 'transactions-bonus-rewards',
      // },
    ],
  },
  {
    title: 'insights',
    icon: 'MonitorIcon',
    children: [
      // {
      //   title: 'customers',
      //   route: 'merchant-customers',
      //   icon: 'UsersIcon'
      // },
      {
        title: 'reports',
        route: 'reports',
        icon: 'ListIcon'
      },
      // {
      //   title: 'platformPayment',
      //   route: 'platform-payments',
      //   icon: 'ListIcon'
      // },
    ]
  },
  {
    title: 'settings',
    icon: 'SettingsIcon',
    children: [
      // {
      //   title: 'security',
      //   route: 'account-security',
      //   icon: 'ShieldIcon',
      // },
      {
        title: 'fees',
        route: 'settings-fees',
        icon: 'ToggleRightIcon'
      },
      {
        title: 'settlementAccounts',
        route: 'settings-settlement',
        icon: 'ToggleRightIcon'
      },
      {
        title: 'lowBalanceAlert',
        route: 'settings-low-balance-alert',
        icon: 'AlertTriangleIcon'
      },
      {
        title: 'automaticSettlement',
        route: 'settings-auto-settlement',
        icon: 'MenuIcon'
      },
      {
        title: 'paymentSettings',
        route: 'settings-payment-settings',
        icon: 'ToggleRightIcon'
      },
      {
        title: 'paymentMethods',
        icon: 'DatabaseIcon',
        route: 'settings-payment-methods'
      },
      {
        title: 'customerPaymentOptions',
        icon: 'ToggleRightIcon',
        route: 'settings-customer-payment-options'
      },
      {
        title: 'securitySettings',
        route: 'settings-security',
        disabled,
        icon: 'ShieldIcon'
      },
      // {
      //   title: 'security',
      //   route: 'settings-security-settings',
      //   icon: 'ShieldIcon'
      // },
      {
        title: 'userSettings',
        // sandbox: false,
        disabled,
        icon: 'UserIcon',
        route: 'pages-account-setting',
        // href: `${utils.goToOneStopPortal()}/account-setting`
      },
      {
        title: 'usersAndAccess',
        route: 'team',
        icon: 'UsersIcon'
      },
    ]
  },
  {
    title: 'appsAndServices',
    icon: 'BoxIcon',
    disabled,
    href: location.origin + '/apps-and-services',
    // onclick(){
    //   console.log('clicked a menu item')
    //   window.open(utils.goToOtherServices(utils.goToOneStopPortal()), '_blank')
    // }
  },
  {
    title: 'smsAndMessaging',
    icon: 'MessageSquareIcon',
    disabled,
    href: location.origin + '/messaging',
    // onclick(){
    //   console.log('clicked a menu item')
    //   window.open(utils.goToOtherServices(utils.goToOneStopPortal()), '_blank')
    // }
  },
  {
    title: 'payBills',
    icon: 'FileTextIcon',
    disabled,
    href: location.origin + '/bill-payment',
    // href: `${utils.goToOtherServices(utils.oneStopPortal + '/bill-payment')}`
  },
  {
    header: '',
    icon: 'NoIcon',
    disable: true
  },
  {
    title: 'developer',
    icon: 'CodeIcon',
    children: [
      {
        title: 'developerPortal',
        icon: 'GlobeIcon',
        // route: 'settings-developer',
        href: location.origin + '/developer',
      },
      {
        title: 'apiDocumentation',
        icon: 'GlobeIcon',
        // route: 'settings-developer',
        href: location.origin + '/api-docs',
      },
      {
        title: 'environment',
        icon: 'CodesandboxIcon',
        children: [
          {
            title: 'production',
            icon: 'CodesandboxIcon',
            route: 'developer-environment-production',
            disabled: env == 'production',
            tag: env == 'production' ? 'active': '',
            tagVariant: 'light-success'
          },
          {
            title: 'sandbox',
            icon: 'CodesandboxIcon',
            route: 'developer-environment-sandbox',
            disabled: env == 'sandbox',
            tag: env == 'sandbox' ? 'active': '',
            tagVariant: 'light-success'
          },
        ]
      },
    ]
  },
  // {
  //   title: 'settlements',
  //   route: 'settlements-all',
  //   icon: "ColumnsIcon"
  // },
  // {
  //   title: 'settlements',
  //   icon: 'ChevronsLeftIcon',
  //   children: [
  //     {
  //       title: 'history',
  //       route: 'settlements-all',
  //     },
  //     {
  //       title: 'payouts',
  //       route: 'settlements-payouts',
  //     },
  //   ]
  // },
  // {
  //   title: 'giftCards',
  //   route: 'engagement-gift-cards'
  // },
  // {
  //   title: 'coupons',
  //   route: 'engagement-coupons'
  // },
  // {
  //   title: 'luckyMoney',
  //   route: 'engagement-lucky-money'
  // },
  // {
  //   title: 'settlements',
  //   route: 'merchant-settlements',
  //   icon: 'BookIcon'
  // },

  // {
  //   title: 'appSettings',
  //   route: 'account-app-settings'
  // },
  // {
  //   header: 'generate',
  // },
  {
    title: 'merchantSolutions',
    icon: 'BookIcon',
    children: [
      // {
      //   title: 'paymentAuthorizations',
      //   route: 'merchant-payment-authorizations',
      //   icon: 'BookIcon'
      // },
    ],
  },
  // {
  //   header: 'users'
  // },
  // {
  //   title: 'team',
  //   route: 'merchant-team',
  //   icon: 'BookIcon'
  // },
  // {
  //   title: 'apiKeys',
  //   route: 'developer-api',
  //   icon: 'CodeIcon'
  // },
  // {
  //   title: 'docs',
  //   //route: 'developer-docs',
  //   icon: 'CodeIcon'
  // },
  // {
  //   title: 'File Manager',
  //   icon: 'FileTextIcon',
  //   children: [
  //     {
  //       title: 'Image',
  //       route: 'image',
  //     },
  //     {
  //       title: 'Audio',
  //       route: 'audio',
  //     },
  //   ],
  // },
  // {
  //   title: 'Some item',
  //   route: 'email',
  //   icon: 'MailIcon',
  // },

  // {
  //   title: 'Transactions',
  //   route: 'transactions-list',
  //   icon: 'BarChart2Icon'
  // },
  // {
  //   title: 'Exchange Rate',
  //   route: 'exchange-rate-list',
  //   icon: 'ActivityIcon'
  // },
]